module.exports = __webpack_public_path__ + "fa-solid-900.svg?65e9a3587ed661cd6628bfbfbe586ea0";